import { Link } from "./CanonicalLink";
import AdSlot from './AdSlot';
import { STORIES } from '../data/stories';
import { titleCaseHeadline } from '../utils/titleCase';

export default function NewsSidebar({ excludeId, sticky = false }) {
  const latest = STORIES.filter(story => story.id !== excludeId).slice(0, 6);
  return <aside className={`min-w-0 self-start ${sticky ? "lg:sticky lg:top-6" : ""}`} aria-label="Advertisements and latest stories">
    <AdSlot placement="article-sidebar-top" />
    <div className="border-t-[4px] border-[#cf0a0a] bg-[var(--bg)] p-5">
      <h2 className="font-display text-[22px] font-semibold mb-4">Latest Stories</h2>
      <div className="divide-y divide-[var(--line)]">
        {latest.map(story => <Link key={story.id} to={`/${story.id}`} className="group flex gap-3 py-4 first:pt-0 last:pb-0">
          <img src={story.img || '/story-placeholder.svg'} alt="" loading="lazy" className="img-frame w-20 h-16 shrink-0 object-cover" />
          <h3 className="min-w-0 font-display text-[16px] leading-[1.3] line-clamp-3 group-hover:text-[var(--accent)] transition-colors">{titleCaseHeadline(story.title)}</h3>
        </Link>)}
      </div>
    </div>
    <AdSlot placement="article-sidebar-bottom" />
  </aside>;
}
